/* eslint-disable */
import _indexOf from 'lodash/indexOf';

// constants
import {
  PLACES,
  TSLA_HEADER_MAIN,
  DIRECTIONS_LISTENER,
  DRAGGABLE_DESTINATION_CHARGERS,
  ROUTE_MOBILE,
} from './Constants';

// helpers
// eslint-disable-next-line import/no-cycle
import { getNodeHeight } from './Utils';

class Enliven {
  constructor() {
    // constants
    this.TOP_POS = 0;
    this.TIMEOUT = 25;
    this.VISIBILE = 200;
    this.STARTING_POS = {};
    this.SLIDE_UP = 'slideUp';
    this.SLIDE_DOWN = 'slideDown';
    this.SLIDING = 'sliding';
    this.SLIDE_LEFT = 'slideLeft';

    // component properties
    this.direction = {};
    this.currentAnimation = {};
    this.currentPos = {};
    this.lastY = {};

    // position properties
    this.clientY = {};
    this.posX = {};
    this.topBounds = {};
    this.positionY = {};
  }

  /**
   * @description Applies the current x,y coordinates to the component on touch start
   *
   * @param {Object} e - Event object
   * @param {string} id - Unique identifier for the component
   *
   * @return {void}
   */
  touchStart(e, id) {
    const node =
      document.getElementById(id) || document.getElementsByClassName(id)[0];

    const currentY = this.getTranslateY(id);
    if (!e.target.classList.contains('directions__btn') || e.touches[0].clientY > 600) {
      this.clientY[id] = e.touches[0].clientY;
      this.currentPos[id] = this.lastY[id];
    }

    this.posX[id] = `${this.getTranslateX(id)}%`;

    node.style.transform = `translate3d(${this.posX[id]}, ${currentY}px, 0)`;
  }

  /**
   * @description Adjusts x and y coordinates as the component is dragged
   *
   * @param {Object} e - Event object
   * @param {string} id - Unique identifier for the component
   *
   * @return {void}
   */
  touchMove(e, id) {
    e.preventDefault();

    const node =
      document.getElementById(id) || document.getElementsByClassName(id)[0];

    const lastY = this.lastY[id];
    const deltaY = e.changedTouches[0].clientY - this.clientY[id];
    const currentPosition = lastY + deltaY;
    const startingPosition = this.STARTING_POS[id];
    this.posX[id] = `${this.getTranslateX(id)}%`;

    if (lastY > currentPosition + 5) {
      this.direction[id] = 'up';
    } else {
      this.direction[id] = 'down';
    }

    this.currentPos[id] = currentPosition;

    // if the component is within top and bottom bounds then transform
    if (
      currentPosition < startingPosition &&
      currentPosition > this.topBounds[id]
    ) {
      node.style.transform = `translate3d(${
        this.posX[id]
        }, ${currentPosition}px, 0)`;
    }
  }

  /**
   * @description Adjusts x and y coordinates once dragging has stopped
   *
   * @param {Object} e - Event object
   * @param {string} id - Unique identifier for the component
   *
   * @return {void}
   */
  touchEnd(e, id) {
    // set the current Y position
    const lastY = this.lastY[id];
    const deltaY = e.changedTouches[0].clientY - this.clientY[id];
    const currentPosition = lastY + deltaY;
    this.currentPos[id] = currentPosition;

    // set the current X position
    this.posX[id] = `${this.getTranslateX(id)}%`;

    // animate on x axis and return early if a user has tapped on a charger
    if (this.handleXAnimation(e, id)) return;

    // apply animations depending on the direction the component is moving, or current Y position
    this.handleYAnimation(id);
  }

  /**
   * @description Slide component left if the user taps on a charger
   *
   * @param {Object} e - Event object
   * @param {string} id - Unique identifier for the component
   *
   * @return {void}
   */
  handleXAnimation(e, id) {
    const currentPosition = this.currentPos[id];

    const target = e.target || e.srcElement;
    const nodes = document.getElementsByClassName(DIRECTIONS_LISTENER);
    let i = 0;
    const nodesLen = nodes.length;
    for (i; i < nodesLen; i += 1) {
      if (nodes[i].contains(target)) {
        if (
          currentPosition !== this.STARTING_POS[id] &&
          currentPosition === this.lastY[id]
        ) {
          const destSelector = DRAGGABLE_DESTINATION_CHARGERS;
          const destXPos = this.getTranslateX(destSelector);
          if (destXPos === -100) {
            this.animate(
              id,
              this.SLIDE_LEFT,
              '-100%',
              '-200%',
              currentPosition,
              currentPosition,
            );
          } else {
            this.animate(
              id,
              this.SLIDE_LEFT,
              0,
              '-100%',
              currentPosition,
              currentPosition,
            );
          }
          return true;
        }
      }
    }

    return false;
  }

  /**
   * @description Animates component depending on the direction the component is moving or the
   *              current Y position.
   *
   * @param {string} id - Unique identifier for the component
   *
   * @return {void}
   */
  handleYAnimation(id) {
    const currentPosition = this.currentPos[id];
    const currentY = this.getTranslateY(id);
    const placesHeight = getNodeHeight(PLACES);
    const endPosition = this.lastY[id] - this.positionY[id] + placesHeight;
    const posX = this.posX[id];

    if (
      currentPosition < placesHeight &&
      currentPosition >= this.topBounds[id]
    ) {
      this.animate(
        id,
        this.SLIDING,
        posX,
        posX,
        currentPosition,
        currentPosition,
        this.SLIDING,
      );
    } else if (
      this.direction[id] === 'up' &&
      currentPosition >= this.topBounds[id]
    ) {
      this.animate(
        id,
        this.SLIDE_UP,
        posX,
        posX,
        currentPosition,
        endPosition,
        'down',
      );
    } else if (
      this.direction[id] === 'down' &&
      currentPosition >= this.topBounds[id]
    ) {
      this.animate(
        id,
        this.SLIDE_DOWN,
        posX,
        posX,
        currentPosition,
        this.STARTING_POS[id],
        'up',
      );
    } else {
      this.animate(
        id,
        this.SLIDING,
        posX,
        posX,
        currentY,
        currentY,
        this.SLIDING,
      );
    }
  }

  /**
   * @description Instantiates Enliven and binds event listeners
   *
   * @param {string} id - Unique identifier for the component
   * @param {integer} startX - Starting X position override
   * @param {integer} startY - Starting Y position override
   *
   * @return {void}
   */
  init({ id, startY, startX }) {
    const node =
      document.getElementById(id) || document.getElementsByClassName(id)[0];

    this.positionY[id] = this.getPositionY();
    this.posX[id] = `${this.getTranslateX(id)}%`;
    this.topBounds[id] = this.getTopBounds(id);
    this.STARTING_POS[id] = this.getPositionY();
    this.lastY[id] = this.positionY[id];
    this.direction[id] = 'up';

    node.style.transform = `translate3d(${this.posX[id]}, ${
      this.positionY[id]
      }px, 0)`;

    if (startY && startX) {
      this.animate(id, this.SLIDE_UP, 0, startX, 0, startY, 'down');
    }

    node.addEventListener(
      'touchstart',
      // eslint-disable-next-line arrow-parens
      e => {
        this.touchStart(e, id);
      },
      false,
    );

    node.addEventListener(
      'touchmove',
      // eslint-disable-next-line arrow-parens
      e => {
        this.touchMove(e, id);
      },
      false,
    );

    node.addEventListener(
      'touchend',
      // eslint-disable-next-line arrow-parens
      e => {
        this.touchEnd(e, id);
      },
      false,
    );
  }

  /**
   * @description Injects CSS keyframes to DOM
   *
   * @param {string} animation - Animation name for component
   * @param {string|integer} xStart - Starting x position
   * @param {string|integer} xEnd - Ending x position
   * @param {string|integer} yStart - Starting y position
   * @param {string|integer} yEnd - Ending y position
   *
   * TODO: refactor for px, % and -
   *
   * @return {void}
   */
  setKeyframes(animation, xStart, xEnd, yStart, yEnd) {
    const startX = _indexOf(xStart, '%') >= 0 ? xStart : `${xStart}px`;
    const endX = _indexOf(xEnd, '%') >= 0 ? xEnd : `${xEnd}px`;
    const startY = _indexOf(yStart, '%') >= 0 ? yStart : `${yStart}px`;
    const endY = _indexOf(yEnd, '%') >= 0 ? yEnd : `${yEnd}px`;

    const keyframes = `@keyframes ${animation} {
        0% {
          transform: translate3d(${startX}, ${startY}, 0);
        }
        100% {
          transform: translate3d(${endX}, ${endY}, 0);
        }
      }`;

    // const styleSheet = document.styleSheets[1];
    // styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  }

  /**
   * @description Applies animations to desired component
   *
   * @param {string} id - Unique identifier for component
   * @param {string} animation - Animation name for component
   * @param {string|integer} xStart - Starting x position
   * @param {string|integer} xEnd - Ending x position
   * @param {string|integer} yStart - Starting y position
   * @param {string|integer} yEnd - Ending y position
   * @param {string=} direction - Option "next" direction for component ie; for when toggling
   *
   * @return {void}
   */
  animate(id, animation, xStart, xEnd, yStart, yEnd, direction = false) {
    const timeout = this.TIMEOUT;

    if (animation !== this.SLIDING) {
      this.setKeyframes(animation, xStart, xEnd, yStart, yEnd);
    }

    if (direction) this.direction[id] = direction;

    // set the animation name & translateY property
    this.lastY[id] = yEnd;
    this.currentAnimation[id] = animation;

    const node =
      document.getElementById(id) || document.getElementsByClassName(id)[0];
    node.style.cssText = `animation: ${animation} .${timeout}s 1;`;
    node.style.cssText += ` transform: translate3d(${xEnd}, ${yEnd}px, 0)`;

    // remove inline styles after desired timeout to stop animation from firing more than once
    setTimeout(() => {
      node.style.cssText = `transform: translate3d(${xEnd}, ${yEnd}px, 0);`;
      // this.removeCSSRules();
    }, timeout * 10);
  }

  /**
   * @description Removes CSS animation rules from DOM
   *
   * @return {void}
   */
  removeCSSRules() {
    const styleSheet = document.styleSheets[1];
    const rules = styleSheet.cssRules;

    let i = 0;
    const rulesLen = rules.length;
    if (rulesLen > 0) {
      for (i; i <= rulesLen; i += 1) {
        try {
          styleSheet.deleteRule(i);
        } catch (e) {
          // console.log('🍠')
        }
      }
    }
  }

  /**
   * @description Gets the current X position of component
   *
   * @param {string} selector - Unique identifier for component
   *
   * @return {integer} X position on users screen
   */
  getTranslateX(selector) {
    const node =
      document.getElementById(selector) ||
      document.getElementsByClassName(selector)[0];
    const translateX = node.style.transform;
    const x = translateX.match(/-\d{1,}|\d{1,}/g) || [];

    return x.length > 0 ? Number(x[1]) : 0;
  }

  /**
   * @description Gets the current Y position of component
   *
   * @param {string} selector - Unique identifier for component
   *
   * @return {integer} Y position on users screen
   */
  getTranslateY(selector) {
    const node =
      document.getElementById(selector) ||
      document.getElementsByClassName(selector)[0];
    const translateY = node.style.transform;
    const y = translateY.match(/-\d{1,}|\d{1,}/g) || [];

    return y.length > 0 ? Number(y[2]) : 0;
  }

  /**
   * @description Gets the y position of the component
   *
   * @return {integer} y position on the screen
   */
  getPositionY() {
    const windowHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0,
    );
    const header = getNodeHeight(TSLA_HEADER_MAIN);

    return windowHeight - this.VISIBILE - header;
  }

  /**
   * @description Calculates how much of the Directions component is visible to the user
   *
   * @return {integer} visible portion of component in px
   */
  getDirectionsInView() {
    const windowHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight || 0,
    );
    const placesHeight = getNodeHeight(PLACES);
    const summaryHeight = getNodeHeight(ROUTE_MOBILE);
    const header = getNodeHeight(TSLA_HEADER_MAIN);

    return windowHeight - placesHeight - summaryHeight - header;
  }

  /**
   * @description Determines the top bounds for draggable components
   *
   * @param {string} selector - Unique identifier for component
   *
   * @return {integer} top bounds for draggable component
   */
  getTopBounds(selector) {
    const node =
      document.getElementById(selector) ||
      document.getElementsByClassName(selector)[0];
    const child = node.children[1] || node.firstChild;

    const directionsInView = this.getDirectionsInView();
    const parentHeight = node.offsetHeight;
    const childHeight = child.offsetHeight;
    const directionsHeight = Math.max(childHeight, parentHeight);
    const summaryHeight = getNodeHeight(ROUTE_MOBILE);

    let topBounds = directionsHeight - directionsInView - summaryHeight;
    topBounds = this.TOP_POS - topBounds;

    return topBounds;
  }
}

export default new Enliven();
